import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../../components/Private/Navbar'
import ListSection from '../../../components/Private/ListSection'
import ModalComponent from '../../../components/Private/ModalComponent'

import contestService from '../../../services/contests'
import applicationService from '../../../services/applications'

import sessionUtils from '../../../utilities/SessionHandler'

export default function List() {

  const navigateTo = useNavigate()

  const [selectedContest, setSelectedContest] = useState(null)
  const [contests, setContests] = useState([])

  let credentials = sessionUtils.getParsedCredentials()

  const handleContestsLoad = async () => {
    const result = await contestService.list()
    let contestItems;

    //order the results by item.id, invert it, and then set it to the contests state

    contestItems = Object.entries(result).map(([key, value]) => value)
    contestItems = contestItems.sort((a, b) => a.id - b.id).reverse()


    setContests(contestItems)
  }

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteModalTitle, setDeleteModalTitle] = useState('Borrar postulación')

  const [contestData, setContestData] = useState(null)
  const [listData, setListData] = useState(null)

  const [selectedItemId, setSelectedItemId] = useState(null)

  const handleDataDelete = async (itemId) => {
    await applicationService.remove(itemId)
    await handleDataLoad()
  }

  const handleDataLoad = async () => {
    if (!credentials) return navigateTo('/home')
    let result;

    if (selectedContest === null) {
      if (sessionStorage.getItem('selectedContest') === null) {
        setSelectedContest(contests[0].id)
        sessionStorage.setItem('selectedContest', contests[0].id)
      } else {
        setSelectedContest(sessionStorage.getItem('selectedContest'))
      }
    }
    let selectedContestInMemory = sessionStorage.getItem('selectedContest')

    switch (parseInt(credentials.businessRole_id)) {
      case 1:
        //result = await applicationService.byCompany(credentials.company_id)
        result = await applicationService.byContestAndCompany(
          [
            selectedContestInMemory,
            credentials.company_id
          ]
        )
        break;
      case 2:
        //result = await applicationService.byCompanyUser(credentials.id)
        result = await applicationService.byContestAndCompanyUser(
          [
            selectedContestInMemory,
            credentials.id
          ]
        )
        break;
      default:
        return navigateTo('/home')
    }
    setListData(result)
  }

  const handleContestLoad = async () => {
    try {
      const result = await contestService.showActive()
      setContestData(result)
    } catch (error) {
      setContestData(false)
    }

  }

  useEffect(() => {
    handleContestsLoad()
  }, [])

  useEffect(() => {
    if (contests && contests.length > 0) {
      handleContestLoad()
    }
  }, [contests])

  useEffect(() => {
    if (contestData) {
      handleDataLoad()
    }
  }, [contestData])


  const handleContestChange = () => {
    let updateDate = document.getElementById('contestId')
    setSelectedContest(updateDate.value)
    sessionStorage.setItem('selectedContest', updateDate.value)
    handleDataLoad()
  }

  useEffect(() => {
    if (contests && contests.length > 0 && listData) {
      if (selectedContest === null) {
        if (sessionStorage.getItem('selectedContest') === null) {
          setSelectedContest(contests[0].id)
          sessionStorage.setItem('selectedContest', contests[0].id)
        } else {
          setSelectedContest(sessionStorage.getItem('selectedContest'))
        }
      }
      let updateDate = document.getElementById('contestId')
      updateDate.value = sessionStorage.getItem('selectedContest')
    }
  }, [contests, listData])

  return (
    <>
      <Navbar companyUser />
      {
        listData && <ListSection
          aboveTitle={
            <div className="container">
              {
                contests && contests.length > 0 && (
                  <div className="row mb-4">
                    <div className="col-12 col-lg-4">
                      <select className="form-select" aria-label="contestFilter" id='contestId' onChange={handleContestChange}>
                        {
                          contests.map((contest, key) => {
                            let fullDate = contest.created_at; //format: YYYY-MM-DD HH:MM:SS
                            //extract Year using React or JavaScript
                            let year = fullDate.date.substring(0, 4);
                            return (
                              <option key={key} value={contest.id}>{contest.contestName} ({year})</option>
                            )
                          })
                        }
                      </select>
                    </div>
                  </div>
                )
              }
            </div>
          }
          title='Postulaciones'
          hasSearch={true}
          hasYear={false}
          tabs={false}
          pagination={
            {
              itemsPerPage: 10,
              maxPagesInPagination: 5,
              currentPage: 1,
              prevPage: 'Anterior',
              nextPage: 'Siguiente',
              lastPage: 'Última',
            }
          }
          backRoute={
            {
              title: 'Volver',
              onClick: () => {
                navigateTo('/home')
              }
            }
          }
          actions={
            contestData.contestActivity === 'Online' && contestData !== false && {
              title: 'Crear postulación',
              onClick: () => {
                navigateTo('/application/create')
              }
            }
          }
          columns={
            [
              {
                title: 'Título de la Postulación',
                field: 'applicationTitle',
                type: 'text',
                sortable: true
              },
              {
                title: 'Categoría',
                field: 'contestDescription',
                type: 'text',
                sortable: true
              },
              {
                title: 'Enviado',
                field: 'applicationStatusEditedByCompanyFirstDateTime',
                type: 'date',
                sortable: true,
                dateFormat: 'DD-MM-YYYY'
              },
              {
                title: 'Estado',
                field: 'applicationStatus',
                type: 'text',
              },
              {
                title: 'Acciones',
                field: 'actions',
                type: 'actions',
              },
            ]
          }
          rows={
            [
              ...listData.map((item, index) => {

                let actions = []

                if (contestData.contestActivity === 'Online' && item.applicationStatusDraft === 'Borrador') {
                  actions = [
                    {
                      className: 'btn',
                      icon: 'bi bi-pencil',
                      tooltip: 'Editar',
                      onClick: () => {
                        navigateTo('/application/edit/' + item.id)
                      }
                    },
                    {
                      className: 'btn',
                      icon: 'bi bi-trash',
                      tooltip: 'Borrar',
                      onClick: () => {
                        setSelectedItemId(item.id)
                        setDeleteModalTitle('Borrar ' + item.applicationTitle)
                        setShowDeleteModal(true)
                      }
                    },
                  ]
                }

                if (item.applicationStatusDraft === 'Enviada') {
                  actions = [
                    {
                      className: 'btn',
                      icon: 'bi bi-eye',
                      tooltip: 'Revisar',
                      onClick: () => {
                        navigateTo('/application/view/' + item.id)
                      }
                    },
                  ]
                }

                if (item.applicationStatusDraft === 'Devuelta') {
                  actions = [
                    {
                      className: 'btn',
                      icon: 'bi bi-pencil',
                      tooltip: 'Editar',
                      onClick: () => {
                        navigateTo('/application/edit/' + item.id)
                      }
                    },
                    {
                      className: 'btn',
                      icon: 'bi bi-trash',
                      tooltip: 'Borrar',
                      onClick: () => {
                        setSelectedItemId(item.id)
                        setDeleteModalTitle('Borrar ' + item.applicationTitle)
                        setShowDeleteModal(true)
                      }
                    },
                  ]
                }

                let itemStatus;

                switch (item.applicationStatusDraft) {
                  case 'Borrador':
                    itemStatus = {
                      text: item.applicationStatusDraft,
                      className: 'status-draft align-middle'
                    }
                    break;
                  case 'Enviada':
                    itemStatus = {
                      text: item.applicationStatusDraft,
                      className: 'status-send align-middle'
                    }
                    break;
                  case 'Devuelta':
                    itemStatus = {
                      text: item.applicationStatusDraft,
                      className: 'status-featured align-middle'
                    }
                    break;
                }

                let appSentDate = item.applicationStatusEditedByCompanyFirstDateTime;
                if (appSentDate) {
                  appSentDate = new Date(appSentDate)
                  appSentDate = appSentDate.toLocaleDateString('es-CL')
                } else {
                  appSentDate = '-'
                }
                appSentDate = {
                  text: appSentDate,
                  className: 'align-middle'
                }

                return {
                  applicationTitle: item.applicationTitle,
                  contestDescription: item.contest.contestDescription,
                  applicationStatusEditedByCompanyFirstDateTime: appSentDate,
                  applicationStatus: itemStatus,
                  actions: actions,
                }
              })
            ]
          }
        />
      }
      <ModalComponent
        id='deleteModal'
        title={deleteModalTitle}
        show={showDeleteModal}
        setShow={setShowDeleteModal}
      >
        <p>¿Está seguro que desea borrar esta postulación?</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => {
              handleDataDelete(selectedItemId)
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Borrar
          </button>
        </div>
      </ModalComponent>
    </>
  )
}
